import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { ComponentStore } from '@ngrx/component-store';
import { catchError, EMPTY, filter, finalize, map, switchMap, tap } from 'rxjs';
import { PROFILE_SERVICE } from './privacy-policy.module';

interface State {
  privacyPolicyAccepted: boolean | null;
}

@Injectable()
export class PrivacyPolicyService extends ComponentStore<State> {
  readonly profileService = inject(PROFILE_SERVICE);
  readonly loadingController = inject(LoadingController);
  readonly router = inject(Router);

  readonly privacyPolicyAccepted$ = this.state$.pipe(
    filter((s) => s.privacyPolicyAccepted !== null),
    map((s) => s.privacyPolicyAccepted as boolean),
  );

  constructor() {
    super({ privacyPolicyAccepted: null });
  }

  acceptPrivacyPolicy = this.effect(($) =>
    $.pipe(
      tap(() => this.loadingController.create().then((c) => c.present())),
      switchMap(() =>
        this.profileService.acceptPrivacyPolicy().pipe(
          tap(() => {
            this.setPrivacyPolicy(true);
            this.router.navigate(['/']);
          }),
          catchError(() => EMPTY),
          finalize(() => this.loadingController.dismiss()),
        ),
      ),
    ),
  );
  setPrivacyPolicy(accepted: boolean) {
    this.patchState({ privacyPolicyAccepted: accepted });
  }
}
